module.exports = "\r\n.footer {\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 2rem;\r\n  bottom: 1%;\r\n  left: 3%;\r\n}\r\n"